import React, { Component } from 'react';
import { Card, Divider, Button } from 'semantic-ui-react'
import Status from '../../../config/OrderStatusConstants.js'
import * as FbUtils from '../../../Utilities/FireBaseUtils'
import * as Utils from '../../../Utilities/Utils'
import * as moment from 'moment';
import { logDashboardAction} from '../../../config/constants';

class NextStatusUpdateButton extends Component {
    constructor(props) {
        super(props);
    }

    handleOnClick = () => {
        console.log("statusSelection:" + this.props.sentStatus);
        this.props.updateFunction(this.props.sentStatus);
    }

    render() {
        return (
            <Button fluid color='orange' onClick={this.handleOnClick}>
                {this.props.buttonText}
            </Button>
        )
    }

}

/**
 * RENDERS THE NEXT BUTTON IN EACH CARD
 * @param {*} props 
 */
export default class NextStatusButton extends Component {
    constructor(props) {
        super(props);

    }


    handleOnClick = (statusSelection) => {
        console.log("nxtb1 statusToUpdate:" + statusSelection);

        let now = moment().format('MMMM Do, h:mm:ss a');
        var d = new Date();
        let orderUpdate = {
            status: statusSelection,
            lastUpdated: now,
            lastUdpatedSecs: d.getTime(),
            lastUpdatedBy:this.props.user.email
        };

        if (statusSelection === Status.delivered) {
            console.log("status is delivered");

            orderUpdate = {
                status: statusSelection,
                lastUpdated: now,
                urgent: false,
                lastUpdatedBy:this.props.user.email
            };
        }

        FbUtils.updateOrder(this.props.order.key, orderUpdate);

        let updateString = this.props.user.email+ " updated order "+this.props.order.order_num+" from "+this.props.order.status +" to "+statusSelection
        console.log("nxtb12 updateString:"+updateString);
        logDashboardAction(updateString, this.props.user.email, this.props.order.order_num,"updateStatus");
        console.log("nxtb13 updateString after logDashboardAction");

        
        let updateText = statusSelection+" - "+this.props.user.email.substring(0,10);
        FbUtils.insertUpdateText(this.props.order.key, updateText, this.props.user.email);

        /**
        * IF ORDER DELIVERED WE NEE TO LOG HOW MANY DAYS SINCE ORDER PLACED
        */
        let daysSince = Utils.GetDaysSinceOrderPlaced(this.props.order.dateNum);
        let eventProperties = {
            status: statusSelection,
            daySinceOrderPlaced: daysSince,
            totalShirts: this.props.order.totalShirts,
            numOrders: this.props.order.numOrders,
            order_num: this.props.order.order_num,
            name: this.props.order.name,
            user: this.props.user.email
        }
    }

    render() {
        let nextButton = (
            <Button onClick={this.props.verifyDesign}>
                BLANK
            </Button>
        )
        // console.log("switch order status:" + this.props.order.status);
        switch (this.props.order.status) {

            //#1 NEW ORDER
            case Status.new:
                nextButton = <NextStatusUpdateButton
                    sentStatus={Status.designing_started} updateFunction={this.handleOnClick}
                    buttonText={'Start Design'}
                />
                break;

            // customer_contacted
            // case Status.customer_contacted:
            //     nextButton = <NextStatusUpdateButton
            //         sentStatus={Status.ready_to_design} updateFunction={this.handleOnClick}
            //         buttonText={'Ready to design'}
            //     />
            //     break;

            // ready_to_design
            // case Status.ready_to_design:
            //     nextButton = <NextStatusUpdateButton
            //         sentStatus={Status.designing_started} updateFunction={this.handleOnClick}
            //         buttonText={'Start Design'}
            //     />
            //     break;


            // designing_started
            case Status.designing_started:
                nextButton = <NextStatusUpdateButton
                    sentStatus={Status.new_design_added} updateFunction={this.handleOnClick}
                    buttonText={'Added New Design'}
                />
                break;

            // new_design_added
            case Status.new_design_added:
                nextButton = <NextStatusUpdateButton
                    sentStatus={Status.clnt_chckng_dsgn} updateFunction={this.handleOnClick}
                    buttonText={'Clnt Checking'}
                />
                break;

            // clnt_chckng_dsgn
            case Status.clnt_chckng_dsgn:
                nextButton = <NextStatusUpdateButton
                    sentStatus={Status.clnt_apprvd_dsgn} updateFunction={this.handleOnClick}
                    buttonText={'Clnt Approved'}
                />
                break;

            // clnt_rejectd_dsgn
            case Status.clnt_rejectd_dsgn:
                nextButton = <NextStatusUpdateButton
                    sentStatus={Status.new_design_added} updateFunction={this.handleOnClick}
                    buttonText={'Add New Design'}
                />
                break;

            // clnt_apprvd_dsgn
            case Status.clnt_apprvd_dsgn:
                nextButton = <NextStatusUpdateButton
                    //sentStatus={Status.start_dsng_kimoto} updateFunction={this.handleOnClick}
                    sentStatus={Status.find_shirt} updateFunction={this.handleOnClick}
                    buttonText={'Find Shirt'}
                />
                break;

            // start_dsng_kimoto
            // case Status.start_dsng_kimoto:
            //     nextButton = <NextStatusUpdateButton
            //         sentStatus={Status.fin_dsng_kimoto} updateFunction={this.handleOnClick}
            //         buttonText={'Finsh Kimoto Design'}
            //     />
            //     break;

            // fin_dsng_kimoto
            // case Status.fin_dsng_kimoto:
            //  nextButton = <NextStatusUpdateButton
            //      sentStatus={Status.start_dsng_scrn} updateFunction={this.handleOnClick}
            //      buttonText={'Start Screen Design'}
            //  />
            //  break;

            // // start_dsng_scrn
            // case Status.start_dsng_scrn:
            // nextButton = <NextStatusUpdateButton
            //     sentStatus={Status.fin_dsng_scrn} updateFunction={this.handleOnClick}
            //     buttonText={'Finish dsgn screen'}
            // />
            // break;

            // fin_dsng_scrn
            // case Status.fin_dsng_scrn:
            // nextButton = <NextStatusUpdateButton
            //     sentStatus={Status.screen_printing} updateFunction={this.handleOnClick}
            //     buttonText={'Fin dsgn screen'}
            // />
            // break;

            // case Status.fin_dsng_kimoto:
            //     nextButton = <NextStatusUpdateButton
            //         sentStatus={Status.printing} updateFunction={this.handleOnClick}
            //         buttonText={'Start printing shirt'} />

            //     break;

            //fin_dsng_kimoto
            // case Status.fin_dsng_kimoto:
            //     nextButton = <NextStatusUpdateButton
            //         sentStatus={Status.find_shirt} updateFunction={this.handleOnClick}
            //         buttonText={'Find Shirt'} />
            //     break;

            //fin_dsng_kimoto
            // case Status.kimoto_printed:
            //     nextButton = <NextStatusUpdateButton
            //         sentStatus={Status.find_shirt} updateFunction={this.handleOnClick}
            //         buttonText={'Find Shirt'} />
            //     break;

            //find_shirt
            case Status.find_shirt:
                nextButton = <NextStatusUpdateButton
                    sentStatus={Status.shirt_found} updateFunction={this.handleOnClick}
                    buttonText={'Shirt Found'} />
                //''
                break;

            //find_shirt
            case Status.shirt_found:
                nextButton = <NextStatusUpdateButton
                    sentStatus={Status.printing} updateFunction={this.handleOnClick}
                    buttonText={'Start Printing'} />
                break;

            //
            case Status.printing:
                nextButton = <NextStatusUpdateButton
                    sentStatus={Status.packing} updateFunction={this.handleOnClick}
                    buttonText={'Start Packing'} />
                break;
            case Status.packing:
                nextButton = <NextStatusUpdateButton
                    sentStatus={Status.out_delivery} updateFunction={this.handleOnClick}
                    buttonText={'Start DELIVERY'}
                />
                break;
            case Status.out_delivery:
                nextButton = <NextStatusUpdateButton
                    sentStatus={Status.delivered} updateFunction={this.handleOnClick}
                    buttonText={'Order Delivered'} />
                break;
            default:
                nextButton = <p>ORDER COMPLETE</p>
                break;
        }

        return (
            <div>
                <Divider horizontal>{'NEXT STATUS'}</Divider>
                {nextButton}
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/NextStatusButton.js